import React, { Component } from 'react'
import '../../css/components/CommonComponents/MoreOptionPopup.css'
import {commitMutation, graphql} from "react-relay";
import environment from "../../RelayEnvironment";
import { apiBaseUrl } from "../../utility/utilities";

class MoreOptionPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            downloadingInProgress: false
        }
    }
    
    handleChild = (e) => {
        e.stopPropagation();
    }

    testForLogin = () => {
        if ((this.props.userData == null || 
          this.props.userData.currentUser == null || 
          this.props.userData.currentUser.edges.length == 0) && 
          this.props.handleLoginPopUp != null)
        {
            // prompt for login if needed
            this.props.handleLoginPopUp();
            return true;
        }
        return false;
    }
    
    handleSelectArea = () => {
        this.props.onSelectArea();
    }
        
    handleMaskToggle = () => {
        this.props.onMaskToggle();
    }
    
    handleSaveMap = () => {
        this.props.onSaveMap();
    }

    handleExportMap = () => {
        this.props.onExportMap();
    }
        
    handleDownloadData = () => {
        const {savedAreaIdSelected, filterByArea, indicatorIdArray} = this.props;
        // define data to download and request CSV file
        // first check if we have indicators selected and are not already downloading
        if(indicatorIdArray == null || indicatorIdArray.length == 0) {
            this.props.onDownloadMenu();
            return;
        }

        if(this.state.downloadingInProgress===true) {
            return;
        }

        if(indicatorIdArray == null || indicatorIdArray.length == 0) {
            this.props.onDownloadData(true);
            return;
        }

        this.setState({downloadingInProgress:true});
        // upload selected indicators and geography via mutation, use return value to download csv
        const mutation = graphql`
            mutation MoreOptionPopupDownloadMapDataMutation($input: CreateDataSetDownloadInput!) {
                createDataSetDownload(input: $input) {
                    dataSetDownloadNode {
                      id
                    }
                }
            }    
            `;
        
        var geographicProfiles = [];
        if(filterByArea === true && savedAreaIdSelected != null && savedAreaIdSelected !== "") {
            var geographicFilters = [{"savedAreaId": savedAreaIdSelected}];
            geographicProfiles.push({"geographicFilters": geographicFilters});
        }
        const variables = {
            "input": {
                "indicators": indicatorIdArray,
                "geographicProfiles": geographicProfiles
            }
        };
  
        // get data with basic error handling and responsive progress dialogue
        commitMutation(
          environment,
          {
              mutation,
              variables,
              onCompleted: (response, errors) => {
                  this.setState({downloadingInProgress:false});
                  // download the file at download ID
                  window.location.assign(`${apiBaseUrl}bsdata/downloaddataset/${response.createDataSetDownload.dataSetDownloadNode.id}`);
                  console.log(`Download URL: https://www.broadstreet.io/bsdata/downloaddataset/${response.createDataSetDownload.dataSetDownloadNode.id}`);
                  this.props.onDownloadData();
              },
              onError: (err) => { 
                  console.error(err); 
                  alert('Error downloading csv data');
                  this.setState({downloadingInProgress:false});
                  this.props.onDownloadData();
              },
          },
        );

    }
    
    render() {
        const visibility = this.props.isVisible
        return (
            <div className="MoreoptionlistContainer" style={{ top: this.props.y, left: this.props.x, zIndex: 9999}} onClick={this.handleChild}>
                {
                    visibility ? <div>
                    {/* <span className="coming-soon" style={{"position": "absolute", "top": "175px", "left": "30px", "transform": "rotate(-15deg)"}}>Coming Soon!</span> */}
                        <ul className="moreoptionlist">
                            <li ref="selectAreaButton" onClick={this.handleSelectArea}>Select an Area</li>
                            <li onClick={this.handleMaskToggle}>Turn Mask Off / On</li>
                            <li onClick={this.handleSaveMap}>Save Map</li>
                            <li ref="exportMapButton" onClick={this.handleExportMap}>Export Image as PNG</li>
                            <li ref="downloadDataButton" onClick={this.handleDownloadData}>{this.state.downloadingInProgress === true ? "RETRIEVING DATA" : "Download Data"}</li>
                        </ul>
                    </div> : null
                }
            </div>
        )
    }
}

export default MoreOptionPopup


// WEBPACK FOOTER //
// ./src/components/CommonComponents/MoreOptionPopup.js